import * as z from "zod";
import type { TFunction } from "i18next";
import { UserRole } from "../types";

export const createUserSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t("management.users.validation.nameRequired")),
    email: z
      .string()
      .email(t("management.users.validation.emailInvalid"))
      .min(1, t("management.users.validation.emailRequired")),
    role: z
      .enum([UserRole.owner, UserRole.ownerViewer, UserRole.user])
      .refine((val) => !!val, {
        message: t("management.users.validation.roleRequired"),
      }),
    phone: z.string().min(1, t("management.users.validation.phoneRequired")),
    department: z.string().optional(),
    position: z.string().optional(),
  });

export type UserFormData = z.infer<ReturnType<typeof createUserSchema>>;

export const userFilterSchema = z.object({
  name: z.string().default(""),
  email: z.string().default(""),
  role: z.nativeEnum(UserRole).optional(),
});

export type UserFilterData = z.infer<typeof userFilterSchema>;
